import { render, staticRenderFns } from "./packagelist.vue?vue&type=template&id=48272247&scoped=true&"
import script from "./packagelist.vue?vue&type=script&lang=js&"
export * from "./packagelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48272247",
  null
  
)

export default component.exports